import React from 'react';
import { useSelector } from 'react-redux';
import { PROMO } from '../../constants/routes';
import { useNavigate } from 'react-router';
import PikkoPointLayout from '../../components/pikko-box/PikkoPointLayout';
import { formatFidelityPoints } from '../../utils/StringUtils';
import { notifySuccess, notifyConfirmation } from '../../utils/Notify';
import { purchasePromo } from '../../actions/userActions';
import { getPromo } from '../../actions/cartActions';
import { useEffect, useState } from 'react';
import useAxios
 from '../../axios/useAxios';
import { CART } from '../../constants/routes';
import { useDispatch } from 'react-redux';
import ConversionTile from '../promo/ConversionTile';
import couponRemise from '../../styles/img/coupon-remise.png';

const Recompense = () => {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const { cartItems } = useSelector((state) => state.cart);
  const navigate = useNavigate();
  const axiosInstance = useAxios();
  const [selectedPromoLoading, setSelectedPromoLoading] = useState(undefined);
  const [promoToPurchase, setPromoToPurchase] = useState([]);
  
  useEffect(() => {
    axiosInstance
      .get('/promos/purchase')
      .then((response) => setPromoToPurchase(response.data))
      .catch((error) => console.error({ error }));
  }, []);

  const isPromoDisabled = (promoItem) => {
    return (
      user.fidelity < promoItem.cost ||
      (selectedPromoLoading !== undefined &&
        selectedPromoLoading !== promoItem._id)
    );
  };

  const callBackRedirect = (promoItem) => {
    notifySuccess(
      'Promotion appliquée',
      `Ta promotion de ${promoItem.price}€ vient d'être appliquée à ton panier.`,
      "J'ai compris",
    );
    navigate(CART);
  };

  const handlePurchasePromo = (promoItem, autoActivation) => {
    axiosInstance
      .get(`/user/${user._id}/promotion/${promoItem._id}`)
      .then((response) => {
        dispatch(purchasePromo(response.data));
        if (autoActivation) {
          // Dans ce cas, on active automatiquement le coupon et on renvoie vers la page de promo
          dispatch(
            getPromo(cartItems, axiosInstance, promoItem, () =>
              callBackRedirect(promoItem),
            ),
          );
        } else {
          navigate(PROMO);
        }
      })
      .catch((error) => console.log({ error }))
      .finally(() => setSelectedPromoLoading(undefined));
  };

  const onPromoClick = (promoItem) => {
    if (cartItems.itemsPrice - promoItem.price < 1) {
      notifyConfirmation(
        'Attention',
        `Si tu convertis tes points, tu ne pourras pas profiter de cette promotion sur ton panier. Le montant total ne doit pas être inférieur à 1€.`,
        'Oui',
        'Non',
        () => handlePurchasePromo(promoItem),
        'warning',
      );
    } else {
      notifyConfirmation(
        'Convertis tes points',
        `Es-tu sûr de vouloir convertir tes ${formatFidelityPoints(promoItem.cost)} Pikkos points ?`,
        'Oui',
        'Non',
        () => handlePurchasePromo(promoItem, true),
      );
    }
  };

  if (!user._id) {
    return <></>;
  }

  return (
    <PikkoPointLayout onBack={() => navigate(PROMO)}>
      <div className="conversion-tile-container">
        {promoToPurchase.map((promoItem) => (
          <ConversionTile
            key={promoItem._id}
            name={promoItem.description}
            cost={formatFidelityPoints(promoItem.cost)}
            icon={couponRemise}
            disabled={isPromoDisabled(promoItem)}
            onValidate={() => onPromoClick(promoItem)}
            isLoading={promoItem._id === selectedPromoLoading}
          />
        ))}
      </div>
      {/* <GiftSurprise user={user} giflocation={'back-button'} /> */}
    </PikkoPointLayout>
  );
};
export default Recompense;
